import React, { useEffect } from "react";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";

export default function PageShell({ children, title }) {
  useEffect(() => {
    if (title) document.title = title;
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [title]);

  return (
    <div className="min-h-screen bg-bone text-ink">
      <Nav />
      <main className="pt-[68px]">{children}</main>
      <Footer />
    </div>
  );
}
